import React from 'react'

type InfoEvalPerformanceCollaboratorProps ={
  nameComplete:string , 
  email:string,   
  sede:string,
  proyecto:string,
  dateAdmission:string

}

const InfoEvalPerformanceCollaborator = ({nameComplete,email,sede,proyecto,dateAdmission}:InfoEvalPerformanceCollaboratorProps) => {
  return (
    <div className='containerCollaboratorInfo'>
      <div className='containerIndividualCollaboratorInfo'>
        <div><span className="titleInfoEvalPerQual">{nameComplete}</span> </div>
        <div><span className="infoEvalPerformanceQual">{email}</span></div>
      </div>
      <div className="vertical-line"></div>
      <div className='containerIndividualCollaboratorInfo'>
        <div><span className="titleInfoEvalPerQual">Sede</span> </div>
        <div><span className="infoEvalPerformanceQual">{sede}</span></div>
      </div>
      <div className="vertical-line"></div>
      <div className='containerIndividualCollaboratorInfo'>
        <div><span className="titleInfoEvalPerQual">Proyecto</span> </div>
        <div><span className="infoEvalPerformanceQual">{proyecto}</span></div>
      </div>
      <div className="vertical-line"></div>
      <div className='containerIndividualCollaboratorInfo'>
        <div><span className="titleInfoEvalPerQual">Fecha de admisión</span> </div>
        <div><span className="infoEvalPerformanceQual">{dateAdmission}</span></div>
      </div>
    </div>
  )
}

export default InfoEvalPerformanceCollaborator